import { Type } from '@angular/core';
import { ConfigurationMaskItemComponent } from './configuration-mask-item.component';
import { IFieldTemplateConfiguration } from 'src/app/core/template-configuration/template-configuration-base';

export class ConfigurationMaskItem<T extends ConfigurationMaskItemComponent> {
  constructor(public component: Type<T>, public data: IFieldTemplateConfiguration) {}
}
